import { isLocalhost } from "./serviceWorker"


export const BACKEND_URL = 'https://dev.aptetutbackend.com/';
export const LOCAL_BACKEND_URL = 'http://localhost:5001/';
export const API_URL = isLocalhost ? LOCAL_BACKEND_URL : BACKEND_URL;
